import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Image, Modal } from "react-bootstrap";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";

import nitinImg from "../../assets/team/nitin-pandey.png";
import harshImg from "../../assets/team/harsh-goyal.jpeg";
import shashankImg from "../../assets/team/shashank-dwivedi.png";
import SImage from "../../assets/Sign/S.png";

const About = () => {
  const [show, setShow] = useState(false);
  const [modalContent, setModalContent] = useState({});

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.onbeforeunload = () => window.scrollTo(0, 0);
  }, []);

  const handleShow = (member) => {
    setModalContent(member);
    setShow(true);
  };

  const team = [
    {
      img: nitinImg,
      name: "Nitin Pandey",
      role: "👨‍💼 Founder & CTO",
      vision:
        "Technology is not just code—it's the engine of transformation. I architect scalable, secure, and smart tech platforms that empower businesses to thrive in a digital-first world. My goal is to help clients leap ahead by turning complexity into elegant solutions.",
    },
    // {
    //   img: harshImg,
    //   name: "Harsh Goel",
    //   role: "🧠 Co-founder & CEO",
    //   vision:
    //     "I believe the future belongs to those who dare to dream and build. At Naught Venture, my vision is to transform ambitious ideas into groundbreaking digital solutions that solve real-world problems, accelerate innovation, and create meaningful impact for our clients and their customers.",
    // },
    // {
    //   img: shashankImg,
    //   name: "Shashank Dwivedi",
    //   role: "⚙️ Co-founder & COO",
    //   vision:
    //     "With a sharp focus on operational excellence, I ensure that every project runs like a well-oiled machine. My mission is to build systems that are not only efficient but also deliver tangible and lasting value to our clients. Your success is the benchmark of our operations.",
    // },
  ];

  return (
    <section className="futuristic-about min-h-screen overflow-hidden">
      {/* Futuristic Background with Grid */}
      <div className="futuristic-bg">
        <div className="grid-overlay"></div>
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
        <div className="scan-line"></div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Container className="py-5">
          {/* Founder Vision */}
          <Row className="justify-content-center mb-5">
            <Col xs={12} md={10} lg={8}>
              <Card className="futuristic-card vision-card">
                <Card.Body className="vision-card-body">
                  <div className="section-header my-4 text-center">
                    <h3 className="futuristic-heading gradient-text">
                      🌟 Founder's Vision
                    </h3>
                    <div className="header-accent "></div>
                  </div>

                  <p className="vision-text">
                    "At <strong>Naught Venture Advisors Pvt Ltd</strong> we don't just build software—we architect the future. Our purpose is to turn innovative dreams into digital reality, led by passion, expertise, and an unstoppable drive for excellence.
                    With every project, we push the boundaries of what's possible, blending cutting-edge technology with visionary thinking. Our mission is to empower startups, enterprises, and industries to thrive in a digital-first world. We are not just developers—we are partners in progress, shaping a connected, intelligent, and limitless future.

                    <strong>Think Digital. Think Naught.</strong>"
                  </p>

                  <div className="signature-container">
                    <img
                      src={SImage}
                      alt="Signature"
                      className="signature-img"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Team Cards */}
          <Row className="g-4 justify-content-center" id="team">
            {team.map((member, idx) => (
              <Col xs={12} sm={6} lg={4} key={idx}>
                <Card
                  className="futuristic-card team-card"
                  onClick={() => handleShow(member)}
                >
                  <div className="team-img-wrapper">
                    <div className="team-img-container">
                      <Image
                        src={member.img}
                        alt={member.name}
                        className="team-img"
                      />
                      <div className="img-glow"></div>
                    </div>
                  </div>
                  <Card.Body className="team-card-body">
                    <h5 className="team-name">{member.name}</h5>
                    <p className="team-role">{member.role}</p>
                    <div className="card-hover-indicator">
                      <span>View Vision</span>
                      <div className="indicator-arrow">→</div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Stats Section */}
          <Row className="text-center mt-5 mb-5 g-4">
            {[
              { label: "Projects Delivered", value: 100 },
              { label: "Industries Served", value: 10 },
              { label: "Client Satisfaction", value: 100 },
              { label: "Years of Experience", value: 13 },
            ].map((stat, index) => (
              <Col xs={6} sm={6} md={3} key={index}>
                <div className="futuristic-card stat-card">
                  <h4 className="stat-value gradient-text">
                    <CountUp end={stat.value} duration={2.5}>
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                    {stat.label === "Client Satisfaction" ? "%" : "+"}
                  </h4>
                  <p className="stat-label">{stat.label}</p>
                </div>
              </Col>
            ))}
          </Row>

          {/* Testimonials */}
          <Row className="mt-5">
            <Col xs={12}>
              <div className="section-header mb-5">
                <h3 className="futuristic-heading gradient-text text-center">
                  💬 What Our Clients Say
                </h3>
                <div className="header-accent center"></div>
              </div>
              <Row className="g-4">
                {[
                  {
                    name: "Nick Bedford – Co-Managing MD, Limited Space",
                    text: "Naught Venture Advisors Pvt Ltd has demonstrated excellent responsiveness, task implementation, and problem-solving. The team has an organized approach and works well with the client. Naught Venture Advisors Pvt Ltd's speed and willingness to understand the client's needs are commendable.",
                  },
                  {
                    name: "Shivam Chaurasia – Plutonic Services",
                    text: "Naught Venture Advisors Pvt Ltd delivered on time and met our needs. Their work led to five highly scalable microservices developed and deployed. The team provided timely deliverables, met the client's needs, and demonstrated professionalism during the project. Naught Venture Advisors Pvt Ltd was professional and attentive to detail.",
                  },
                  {
                    name: "Nick Ghattas – CEO, Bastion Group Australia",
                    text: "Naught Venture Advisors Pvt Ltd exceeded the client's expectations. Moreover, the team delivered quality work that improved our revenue. Overall, the team was highly professional, and their project management approach was truly commendable.",
                  },
                ].map((review, idx) => (
                  <Col xs={12} md={4} key={idx}>
                    <Card className="futuristic-card testimonial-card">
                      <Card.Body>
                        <div className="testimonial-quote">"</div>
                        <p className="testimonial-text">"{review.text}"</p>
                        <h6 className="testimonial-author" style={{ whiteSpace: "nowrap" }}>{review.name}</h6>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* What Sets Us Apart */}
          <Row className="mt-5">
            <Col xs={12}>
              <div className="section-header mb-5">
                <h3 className="futuristic-heading gradient-text text-center">
                  🚀 What Sets Us Apart
                </h3>
                <div className="header-accent center"></div>
              </div>
              <Row className="g-4">
                {[
                  {
                    title: "Tailored Digital Solutions",
                    text: "Every business is unique. We design solutions that align precisely with your goals, audience, and workflows.",
                    icon: "🎯",
                  },
                  {
                    title: "End-to-End Expertise",
                    text: "From UI/UX and frontend to robust backends and IoT integrations—we handle it all, seamlessly.",
                    icon: "🔄",
                  },
                  {
                    title: "Reliable Long-Term Support",
                    text: "We don't vanish after delivery. Our team stays with you to iterate, scale, and maintain your systems.",
                    icon: "🛡️",
                  },
                ].map((item, idx) => (
                  <Col xs={12} md={4} key={idx}>
                    <Card className="futuristic-card feature-card">
                      <Card.Body>
                        <div className="feature-icon">{item.icon}</div>
                        <h5 className="feature-title">{item.title}</h5>
                        <p className="feature-text">{item.text}</p>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* Why Clients Choose Us */}
          <Row className="mt-5">
            <Col xs={12}>
              <div className="section-header mb-5">
                <h3 className="futuristic-heading gradient-text text-center">
                  💡 Why Clients Choose Us
                </h3>
                <div className="header-accent center"></div>
              </div>
              <Row className="g-4">
                {[
                  "Futuristic, modern UI/UX",
                  "Experienced full-stack team",
                  "Agile and transparent process",
                  "Dedicated project ownership",
                  "Fast turnaround with quality",
                  "Proven client satisfaction",
                ].map((point, index) => (
                  <Col xs={12} sm={6} md={4} key={index}>
                    <Card className="futuristic-card benefit-card">
                      <Card.Body className="d-flex align-items-center">
                        <div className="benefit-check">✓</div>
                        <p className="benefit-text">{point}</p>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          {/* CTA Section */}
          <Row className="text-center mt-5 mb-5">
            <Col xs={12}>
              <div className="cta-section">
                <h3 className="cta-heading gradient-text">
                  Let's Build the Future Together
                </h3>
                <p className="cta-subtitle">
                  Have a dream project or an idea that needs expert execution?
                </p>
                <a 
                  href="/contact" 
                  className="futuristic-btn cta-btn"
                >
                  <span>Contact Us Now</span>
                  <div className="btn-glow"></div>
                </a>
              </div>
            </Col>
          </Row>

          {/* Team Member Modal */}
          <Modal show={show} onHide={() => setShow(false)} centered size="lg" className="futuristic-modal">
            <Modal.Header closeButton className="modal-header">
              <Modal.Title className="modal-title">{modalContent.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body">
              <p className="modal-role">{modalContent.role}</p>
              <p className="modal-vision">{modalContent.vision}</p>
            </Modal.Body>
          </Modal>
        </Container>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        .futuristic-about {
          position: relative;
          background: #0a0e17;
          color: #e0e0e0;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .futuristic-bg {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          background: 
            radial-gradient(circle at 10% 20%, rgba(26, 92, 255, 0.1) 0%, transparent 20%),
            radial-gradient(circle at 90% 80%, rgba(0, 184, 255, 0.1) 0%, transparent 20%),
            radial-gradient(circle at 50% 50%, rgba(102, 81, 255, 0.05) 0%, transparent 50%);
        }

        .grid-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-image: 
            linear-gradient(rgba(26, 92, 255, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(26, 92, 255, 0.1) 1px, transparent 1px);
          background-size: 50px 50px;
          opacity: 0.3;
        }

        .gradient-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(40px);
          opacity: 0.15;
          animation: float 8s ease-in-out infinite;
        }

        .orb-1 {
          width: 300px;
          height: 300px;
          background: radial-gradient(circle, #1a5cff 0%, transparent 70%);
          top: 10%;
          left: 5%;
          animation-delay: 0s;
        }

        .orb-2 {
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, #00b8ff 0%, transparent 70%);
          bottom: 10%;
          right: 5%;
          animation-delay: 2s;
        }

        .orb-3 {
          width: 250px;
          height: 250px;
          background: radial-gradient(circle, #6651ff 0%, transparent 70%);
          top: 50%;
          left: 80%;
          animation-delay: 4s;
        }

        .scan-line {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #1a5cff, transparent);
          animation: scan 3s linear infinite;
          box-shadow: 0 0 10px #1a5cff;
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0) translateX(0);
          }
          50% {
            transform: translateY(-20px) translateX(10px);
          }
        }

        @keyframes scan {
          0% {
            top: 0%;
          }
          100% {
            top: 100%;
          }
        }

        .futuristic-card {
          background: rgba(16, 22, 36, 0.7);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(26, 92, 255, 0.2);
          border-radius: 16px;
          box-shadow: 
            0 8px 32px rgba(0, 0, 0, 0.2),
            inset 0 1px 0 rgba(255, 255, 255, 0.1);
          transition: all 0.3s ease;
          overflow: hidden;
          position: relative;
        }

        .futuristic-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, #1a5cff, transparent);
        }

        .futuristic-card:hover {
          transform: translateY(-5px);
          border-color: rgba(26, 92, 255, 0.4);
          box-shadow: 
            0 12px 40px rgba(26, 92, 255, 0.15),
            inset 0 1px 0 rgba(255, 255, 255, 0.1);
        }

        .vision-card {
          padding: 2rem;
        }

        .vision-card-body {
          background: rgba(16, 22, 36, 0.5);
          border-radius: 12px;
          padding: 2rem;
        }

        .section-header {
          margin-bottom: 2rem;
          position: relative;
        }

        .futuristic-heading {
          font-weight: 700;
          margin-bottom: 0.5rem;
          font-size: clamp(1.5rem, 2.5vw, 2.2rem);
        }

        .header-accent {
          height: 3px;
          width: 60px;
          background: linear-gradient(90deg, #1a5cff, #00b8ff);
          border-radius: 3px;
          margin:auto;
        }

        .header-accent.center {
          margin: 0 auto;
        }

        .gradient-text {
          background: linear-gradient(135deg, #1a5cff 0%, #00b8ff 50%, #6651ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .vision-text {
          font-size: clamp(0.95rem, 1.8vw, 1.1rem);
          line-height: 1.7;
          text-align: justify;
          color: #b0b8d0;
          margin-bottom: 1.5rem;
        }

        .vision-text strong {
          color: #e0e0e0;
          font-weight: 600;
        }

        .signature-container {
          display: flex;
          justify-content: flex-end;
          margin-top: 1.5rem;
        }

        .signature-img {
          max-width: 180px;
          filter: brightness(0) invert(1);
          opacity: 0.9;
        }

        .team-card {
          cursor: pointer;
          height: 100%;
        }

        .team-img-wrapper {
          display: flex;
          justify-content: center;
          margin-top: 2rem;
          position: relative;
        }

        .team-img-container {
          width: 140px;
          height: 140px;
          border-radius: 50%;
          overflow: hidden;
          position: relative;
          border: 3px solid rgba(26, 92, 255, 0.3);
          box-shadow: 0 0 20px rgba(26, 92, 255, 0.2);
        }

        .team-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: top;
          transition: transform 0.5s ease;
        }

        .img-glow {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          box-shadow: inset 0 0 20px rgba(26, 92, 255, 0.3);
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .team-card:hover .team-img {
          transform: scale(1.05);
        }

        .team-card:hover .img-glow {
          opacity: 1;
        }

        .team-card-body {
          padding: 1.5rem;
          text-align: center;
        }

        .team-name {
          font-weight: 700;
          color: #e0e0e0;
          margin-bottom: 0.5rem;
        }

        .team-role {
          color: #b0b8d0;
          margin-bottom: 1rem;
          font-size: 0.9rem;
        }

        .card-hover-indicator {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1a5cff;
          font-size: 0.9rem;
          opacity: 0;
          transform: translateY(10px);
          transition: all 0.3s ease;
        }

        .team-card:hover .card-hover-indicator {
          opacity: 1;
          transform: translateY(0);
        }

        .indicator-arrow {
          margin-left: 0.5rem;
          transition: transform 0.3s ease;
        }

        .team-card:hover .indicator-arrow {
          transform: translateX(5px);
        }

        .stat-card {
          padding: 1.5rem 1rem;
          text-align: center;
        }

        .stat-value {
          font-weight: 700;
          font-size: clamp(1.8rem, 3vw, 2.5rem);
          margin-bottom: 0.5rem;
        }

        .stat-label {
          color: #b0b8d0;
          font-size: 0.9rem;
          margin-bottom: 0;
        }

        .testimonial-card {
          height: 100%;
          padding: 1.5rem;
        }

        .testimonial-quote {
          font-size: 3rem;
          color: #1a5cff;
          line-height: 1;
          margin-bottom: 0.5rem;
        }

        .testimonial-text {
          color: #b0b8d0;
          font-style: italic;
          line-height: 1.6;
          margin-bottom: 1.5rem;
        }

        .testimonial-author {
          color: #e0e0e0;
          font-weight: 600;
          text-align: right;
        }

        .feature-card {
          height: 100%;
          padding: 1.5rem;
          text-align: center;
        }

        .feature-icon {
          font-size: 2.5rem;
          margin-bottom: 1rem;
        }

        .feature-title {
          font-weight: 600;
          color: #e0e0e0;
          margin-bottom: 1rem;
          font-size: 1.2rem;
        }

        .feature-text {
          color: #b0b8d0;
          line-height: 1.6;
        }

        .benefit-card {
          padding: 1rem 1.5rem;
        }

        .benefit-check {
          color: #00b8ff;
          font-weight: bold;
          margin-right: 1rem;
          font-size: 1.2rem;
        }

        .benefit-text {
          color: #b0b8d0;
          margin-bottom: 0;
        }

        .cta-section {
          padding: 3rem 2rem;
          background: rgba(16, 22, 36, 0.7);
          border-radius: 20px;
          border: 1px solid rgba(26, 92, 255, 0.3);
          position: relative;
          overflow: hidden;
        }

        .cta-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, #1a5cff, #00b8ff, transparent);
        }

        .cta-heading {
          font-weight: 700;
          font-size: clamp(1.5rem, 2.5vw, 2.2rem);
          margin-bottom: 1rem;
        }

        .cta-subtitle {
          color: #b0b8d0;
          font-size: 1.1rem;
          margin-bottom: 2rem;
        }

        .futuristic-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          position: relative;
          background: linear-gradient(135deg, #1a5cff 0%, #00b8ff 100%);
          color: white;
          border: none;
          border-radius: 50px;
          padding: 0.8rem 2rem;
          font-weight: 600;
          font-size: 1rem;
          text-decoration: none;
          overflow: hidden;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(26, 92, 255, 0.3);
        }

        .futuristic-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(26, 92, 255, 0.4);
          color: white;
          text-decoration: none;
        }

        .btn-glow {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s ease;
        }

        .futuristic-btn:hover .btn-glow {
          left: 100%;
        }

        .futuristic-modal .modal-content {
          background: rgba(16, 22, 36, 0.95);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(26, 92, 255, 0.3);
          border-radius: 16px;
          color: #e0e0e0;
        }

        .modal-header {
          border-bottom: 1px solid rgba(26, 92, 255, 0.2);
        }

        .modal-title {
          font-weight: 700;
          color: #e0e0e0;
        }

        .btn-close {
          filter: invert(1);
        }

        .modal-role {
          color: #b0b8d0;
          margin-bottom: 1rem;
        }

        .modal-vision {
          font-style: italic;
          line-height: 1.6;
          color: #b0b8d0;
        }

        @media (max-width: 768px) {
          .team-img-container {
            width: 120px;
            height: 120px;
          }
          
          .vision-card-body {
            padding: 1.5rem;
          }
          
          .cta-section {
            padding: 2rem 1rem;
          }
        }
      `}</style>
    </section>
  );
};

export default About;